/* eslint-disable @typescript-eslint/no-unused-vars */
import { memo, useMemo, useCallback, useEffect } from 'react';
import { useProject } from 'hooks/useProject';
import useProjectInfoProvider from 'hooks/useProjectInfoProvider';
import { drawGridCondition } from 'libs/projectUtils';
import { Grid, Stack, Link } from '@mui/material';
import DialogTextField from 'components/dialog/DialogTextField';
import GridPointBox from './GridPointBox';
import GridPoint from './GridPoint';

function GridResultInfo(): JSX.Element {
  const { getInspectionDetail } = useProject();
  const { dcInputs, onChangeDC } = useProjectInfoProvider();
  const { stepper1, inspectionId } = dcInputs;
  const { data } = getInspectionDetail(inspectionId || '');
  const gridDetail = useMemo(() => {
    return data?.grid || '0,0,0,0,0,0,0,0,0,0,0,0,0';
  }, [data?.grid]);

  const ipsativeRowCount = useMemo(() => {
    return data?.inspectionIpsatives?.length || stepper1.ipsativeExcel.rowCount || 0;
  }, [data?.inspectionIpsatives?.length, stepper1.ipsativeExcel.rowCount]);

  const updateStepperGrid = useCallback(() => {
    const gridValues = gridDetail.split(',');
    drawGridCondition.forEach((obj, index) => {
      onChangeDC(`stepper2.${obj.id}`, gridValues[index]);
    });
  }, [gridDetail, onChangeDC]);

  useEffect(() => {
    updateStepperGrid();
  }, [updateStepperGrid]);

  useEffect(() => {
    onChangeDC('stepper1.ipsativeExcel.rowCount', ipsativeRowCount);
  }, [ipsativeRowCount, onChangeDC]);

  return (
    <Grid container>
      <Grid item xs={5}>
        <DialogTextField
          label="문항수"
          labelSx={{ typography: 's20w700' }}
          text={`${ipsativeRowCount}`}
          variant="outlined"
          name="ipsativeRowCount"
          stackSx={{ display: 'flex', alignItems: { xs: 'flex-start', md: 'center' } }}
        />
      </Grid>
      <Grid item xs={12}>
        <Stack direction="row" spacing={2} justifyContent="space-evenly" sx={{ display: 'flex' }}>
          {drawGridCondition.map(obj => (
            <Stack key={obj.id} direction="column" spacing={2} justifyContent="flex-end">
              {Array.from(
                { length: Number(dcInputs.stepper2[obj.id as keyof typeof dcInputs.stepper2]) },
                (_, index) => (
                  <GridPointBox key={`${obj.id}-${index}`} width={60} height={30} />
                ),
              )}
              <GridPoint
                id={obj.id}
                label={obj.label}
                color={obj.color}
                value={dcInputs.stepper2[obj.id as keyof typeof dcInputs.stepper2]}
                width={60}
                height={100}
                typography="s16w800"
                disabled
              />
            </Stack>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={12} justifyContent="flex-start" sx={{ mt: 2 }}>
        <Link
          underline="always"
          sx={{ cursor: 'pointer', color: '#0F6CBD', typography: 's14w500' }}
          component="button"
          onClick={() => {
            onChangeDC('activeStep', 1);
          }}
        >
          그리드 수정
        </Link>
      </Grid>
    </Grid>
  );
}

export default memo(GridResultInfo);
